<!-- eslint-disable svelte/no-restricted-html-elements -- 
 No link l10n needed, Link component messes up the rich text -->
<p>
	I would like to ask you to work towards treaty negotiations for compute governance, which would
	prevent the worst of the risks that AI poses. One country should take the lead, and at this
	moment, not a single one is doing so.
</p>
<p>
	The most important part of such a document is that there should be some mechanism in place that
	can pause dangerous training runs. Ideally, this happens before a model is trained, as AI
	accidents might happen during lab tests. Implementations of this idea can be found <a
		href="https://pauseai.info/building-the-pause-button">here</a
	>.
</p>
